import { useEffect } from "react";

const ZapierChatbotEmbed = () => {
  // floating button zapier script
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "module";
    script.src = "https://interfaces.zapier.com/assets/web-components/zapier-interfaces/zapier-interfaces.esm.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <zapier-interfaces-chatbot-embed
      is-popup="true"
      chatbot-id="cm4l1dmom000f4xx92c40ql9a"
      height="600px"
      width="400px"></zapier-interfaces-chatbot-embed>
  );
};

export default ZapierChatbotEmbed;
